import { render, staticRenderFns } from "./ObjectSelector.vue?vue&type=template&id=d833715c&scoped=true"
import script from "./ObjectSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectSelector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d833715c",
  null
  
)

export default component.exports